export default __webpack_public_path__ + "3e54fa98922d4a0b1cc8d530baef6045.jpg";